import React from 'react';
import Dsy from './dsyui';
import { createComponent } from '@lit-labs/react';

const LitComp = Dsy.components.DsyContainer;

export const DsyContainer = createComponent(
  React,
  'dsy-container',
  LitComp,
  {},
);
